import { GET_SHIPPING_COST, SHIPPING_COST_ERROR } from "../actions/types";

const initialState = {
  shippingCost: 0,
  customizationCost: 0,
  loading: true,
  error: {}
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SHIPPING_COST:
      return {
        ...state,
        shippingCost: payload.shippingCost,
        customizationCost: payload.customizationCost,
        loading: false
      };
    case SHIPPING_COST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
};
